import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <div className="not-found-card">
        <div className="not-found-number">
          4
          <span className="not-found-dots">
            <span className="not-found-dot" />
            <span className="not-found-dot" />
          </span>
          4
        </div>
        <div className="not-found-title">页面暂时迷路</div>
        <div className="not-found-desc">页面不存在或已被移动</div>
        <button className="not-found-btn" onClick={() => navigate('/home')}>
          返回首页
        </button>
        <div className="not-found-footer">Tomato 综合站 · All Rights Reserved</div>
      </div>
    </div>
  );
};

export default NotFound;
